
const state = {
  alert_emails: [],
  deadline_date: '',
  deadline_time: '',
  deadline_type: 'once',
  description: '',
  enabled_days: [],
  id: null,
  occurs_daily: false,
  owner_id: undefined,
  owner_type: '',
  title: '',
}

export const requiredFields = [
  { key: 'deadline_time' },
  { key: 'description' },
  { key: 'title' },
]

export default state
